var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _rect, _path88, _path89, _path90, _path91, _path92, _path93, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 51,
    fill: "#9C9C9C",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9842 37.1836C75.6824 34.0243 72.8325 29.2002 72.0185 27.8436C67.2468 27.4902 61.5838 27.3105 55.1771 27.3105C43.9856 27.3105 33.8947 27.8639 32.0598 27.971C30.6711 29.3323 28.9041 32.6392 26.8026 37.8107C26.7241 38.0035 26.6634 38.1534 26.6229 38.2498C26.5575 38.4033 26.4861 38.5425 26.4218 38.6675C26.3968 38.7163 26.3659 38.7746 26.3385 38.8305C26.6479 38.9721 27.5094 39.2208 29.8882 39.435C31.8528 39.6111 38.1274 39.7099 47.5519 39.7099C59.6537 39.7099 73.4405 39.5433 74.8721 39.3815C75.3266 39.3303 75.7586 39.3113 76.1406 39.2934C76.6165 39.272 77.3353 39.2399 77.4685 39.1268C77.4769 39.1137 77.6363 38.7663 76.9842 37.1836ZM67.3777 36.9766H38.0191C37.0945 36.9766 36.3449 36.2269 36.3449 35.3023L38.0191 31.6182C38.0191 30.6936 38.7688 29.9439 39.6934 29.9439C39.6934 29.9439 46.2239 29.274 52.8103 29.274C59.3967 29.274 65.3691 29.9439 65.3691 29.9439C66.2937 29.9439 67.0433 30.6936 67.0433 31.6182L69.0532 35.3023C69.052 36.2269 68.3023 36.9766 67.3777 36.9766Z",
    fill: "#5A6060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9954 76.1586C26.9954 77.0832 26.2457 78.0006 25.3211 78.0006H20.2983C19.3725 78.0006 18.7906 77.2474 18.4562 76.1586C18.4562 76.1586 18.0219 73.7037 18.0219 69.1259C18.0219 65.8036 18.1207 64.3268 18.1207 64.3268C18.1207 63.401 19.2059 62.6514 20.1305 62.6514H25.3211C26.2457 62.6514 26.9954 63.401 26.9954 64.3268V76.1586Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9616 76.1586C76.9616 77.0832 77.7113 78.0006 78.6371 78.0006H83.6599C84.5845 78.0006 85.1676 77.2474 85.5019 76.1586C85.5019 76.1586 85.9363 73.7037 85.9363 69.1259C85.9363 65.8036 85.8363 64.3268 85.8363 64.3268C85.8363 63.401 84.7523 62.6514 83.8277 62.6514H78.6371C77.7125 62.6514 76.9616 63.401 76.9616 64.3268V76.1586Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.545 42.3903C79.545 42.3903 85.8244 42.1392 87.1631 41.2182C88.5018 40.2972 88.7529 37.9541 86.1576 37.4508C83.5623 36.9486 80.7147 35.1066 81.4692 40.2127C81.4692 40.2127 79.5438 40.8838 78.2884 40.2127L79.545 42.3903Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0607 41.5523L79.545 42.3901C79.545 42.3901 85.8244 42.139 87.1631 41.2179C87.6688 40.8705 88.0187 40.3195 88.1198 39.7412C86.1743 40.9597 81.2133 41.4107 79.0607 41.5523Z",
    fill: "#212320"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6059 42.3903C24.6059 42.3903 18.3265 42.1392 16.9867 41.2182C15.648 40.2972 15.3957 37.9541 17.9922 37.4508C20.5875 36.9486 23.4338 35.1066 22.6806 40.2127C22.6806 40.2127 24.6071 40.8838 25.8625 40.2127L24.6059 42.3903Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0891 41.5523L24.6059 42.3901C24.6059 42.3901 18.3265 42.139 16.9867 41.2179C16.4809 40.8705 16.1311 40.3195 16.0299 39.7412C17.9767 40.9597 22.9376 41.4107 25.0891 41.5523Z",
    fill: "#212320"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0803 50.8454C86.0517 50.7181 86.0208 50.6062 85.9874 50.5122C85.0545 47.9169 82.0035 46.0749 81.3252 43.3963C80.6481 40.7177 76.0704 31.0053 74.6305 28.9966C73.1895 26.9868 71.6628 25.1697 68.6117 24.6676C65.7689 24.1999 53.7408 24.0226 52.1023 24C52.0999 24 52.0963 24 52.0927 24C52.0904 24 52.0868 24 52.0844 24C50.4458 24.0226 38.4166 24.1999 35.575 24.6676C32.5239 25.1697 30.9984 26.988 29.5573 28.9966C28.1163 31.0065 23.5397 40.7177 22.8615 43.3963C22.1832 46.0761 19.1321 47.9181 18.2004 50.5122C18.1659 50.6062 18.135 50.7181 18.1064 50.8454C17.352 54.2142 18.4539 68.596 18.4539 68.596C18.8775 69.6015 21.7596 71.6934 21.7596 71.6934C24.2133 72.6621 50.2673 73.0083 52.0844 73.0321C52.0868 73.0321 52.0904 73.0321 52.0927 73.0321C52.0951 73.0321 52.0999 73.0321 52.1023 73.0321C53.9193 73.0095 79.9734 72.6632 82.4271 71.6934C82.4271 71.6934 85.3092 69.6003 85.7328 68.596C85.7328 68.596 86.8347 54.213 86.0803 50.8454ZM77.4697 39.1279C77.3365 39.241 76.6177 39.2731 76.1417 39.2945C75.7598 39.3112 75.3278 39.3302 74.8733 39.3826C73.4429 39.5456 59.6549 39.711 47.5531 39.711C38.1286 39.711 31.854 39.6134 29.8893 39.4361C27.5106 39.2219 26.6491 38.9732 26.3397 38.8316C26.3671 38.7757 26.398 38.7162 26.423 38.6686C26.4873 38.5448 26.5599 38.4044 26.6241 38.2509C26.6646 38.1545 26.7253 38.0046 26.8038 37.8118C28.9053 32.6403 30.6723 29.3334 32.061 27.9721C33.8971 27.865 43.9868 27.3116 55.1783 27.3116C61.585 27.3116 67.248 27.4913 72.0197 27.8447C72.8349 29.2013 75.6848 34.0242 76.9854 37.1847C77.6363 38.7662 77.4769 39.1136 77.4697 39.1279Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6048 62.3728C32.6048 62.3728 45.6658 59.5812 72.009 62.0373L71.2272 67.5063L33.1617 67.6182L32.6048 62.3728Z",
    fill: "#C3C3C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7994 57.5181C85.7994 57.5181 84.851 58.9139 84.2929 58.6902L83.6789 56.7375C83.6789 56.7375 83.2886 60.0301 71.2879 60.1979L70.2277 63.6583L66.935 71.0253L63.0855 72.8257C71.1737 72.6282 80.9694 72.2724 82.4271 71.6953C82.4271 71.6953 85.3092 69.6021 85.7328 68.5978C85.7328 68.5978 86.1897 62.6326 86.3135 57.486L85.7994 57.5181ZM35.287 63.6571L34.2267 60.1967C22.226 60.0289 21.8357 56.7363 21.8357 56.7363L21.2217 58.689C20.6636 58.9128 19.7152 57.5169 19.7152 57.5169L17.8708 57.3979C17.9922 62.5635 18.4527 68.5954 18.4527 68.5954C18.8763 69.6009 21.7584 71.6929 21.7584 71.6929C23.3017 72.3033 34.1863 72.6663 42.5005 72.8579L38.5796 71.0241L35.287 63.6571Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7589 36.8636C76.1965 33.0688 72.5124 27.0405 72.5124 27.0405C55.1545 25.7006 31.7124 27.1523 31.7124 27.1523C29.2004 29.3288 26.2981 36.8636 25.8518 37.925C25.4056 38.9853 24.2323 39.7659 29.8156 40.2692C35.3965 40.7714 72.5124 40.4929 74.9684 40.2133C77.4233 39.9337 79.3213 40.6595 77.7589 36.8636ZM77.4697 39.1269C77.3365 39.2399 76.6177 39.272 76.1417 39.2935C75.7598 39.3101 75.3278 39.3292 74.8733 39.3815C73.4429 39.5445 59.6549 39.7099 47.5531 39.7099C38.1286 39.7099 31.854 39.6124 29.8893 39.4351C27.5106 39.2209 26.6491 38.9722 26.3397 38.8306C26.3671 38.7746 26.398 38.7151 26.423 38.6675C26.4873 38.5438 26.5598 38.4034 26.6241 38.2499C26.6646 38.1535 26.7253 38.0035 26.8038 37.8108C28.9053 32.6392 30.6723 29.3323 32.061 27.971C33.8971 27.8639 43.9868 27.3106 55.1783 27.3106C61.585 27.3106 67.248 27.4903 72.0197 27.8437C72.8349 29.2003 75.6848 34.0231 76.9854 37.1837C77.6363 38.7651 77.4769 39.1126 77.4697 39.1269Z",
    fill: "#202022"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3026 62.6514C77.3519 63.7794 53.5897 63.7437 51.8559 63.7402C51.8524 63.7402 51.8476 63.7402 51.844 63.7402C51.8417 63.7402 51.8357 63.7402 51.8333 63.7402C50.0984 63.7437 26.3361 63.7794 22.3855 62.6514C22.3855 62.6514 21.0456 67.0042 25.4829 68.1775C29.906 69.3461 32.1705 70.5134 51.8333 70.5217C51.8369 70.5217 51.8405 70.5217 51.844 70.5217C51.8476 70.5217 51.8512 70.5217 51.8559 70.5217C71.5188 70.5134 73.7833 69.3461 78.2051 68.1775C82.6425 67.0054 81.3026 62.6514 81.3026 62.6514Z",
    fill: "#212320"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3251 44.5619C24.3227 40.3745 26.0303 39.3166 26.0541 39.3047L26.141 39.4475C26.141 39.4475 26.1196 39.4594 26.0767 39.4939C26.0327 39.5272 25.9696 39.5808 25.8935 39.6593C25.74 39.814 25.5341 40.0663 25.3271 40.447C24.913 41.2086 24.4941 42.4902 24.4941 44.5607C24.4941 45.4758 24.5762 46.5444 24.7761 47.7903L24.6107 47.8164C24.4084 46.5646 24.3251 45.4865 24.3251 44.5619Z",
    fill: "#202022"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8889 44.5619C79.8913 40.3745 78.1837 39.3166 78.1599 39.3047L78.073 39.4475C78.073 39.4475 78.0945 39.4594 78.1373 39.4939C78.1813 39.5272 78.2444 39.5808 78.3206 39.6593C78.4741 39.814 78.6787 40.0663 78.887 40.447C79.3023 41.2086 79.7211 42.4902 79.7211 44.5607C79.7211 45.4758 79.6402 46.5444 79.4391 47.7903L79.6045 47.8164C79.8056 46.5646 79.8889 45.4865 79.8889 44.5619Z",
    fill: "#202022"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9037 37.5647C26.8692 37.6468 26.8371 37.7277 26.8026 37.811C26.7241 38.0038 26.6634 38.1537 26.6229 38.2501C26.5575 38.4036 26.4861 38.5428 26.4218 38.6677C26.3968 38.7165 26.3659 38.7748 26.3385 38.8308C26.6479 38.9724 27.5094 39.2211 29.8882 39.4353C31.8528 39.6114 38.1274 39.7102 47.5519 39.7102C59.6537 39.7102 73.4405 39.5436 74.8721 39.3817C75.3266 39.3306 75.7586 39.3115 76.1406 39.2937C76.6165 39.2722 77.3353 39.2401 77.4685 39.1271C77.4769 39.114 77.6244 38.7784 77.0295 37.2969C72.2875 36.3902 63.1201 35.7773 52.5866 35.7773C41.0428 35.7762 31.1388 36.5127 26.9037 37.5647Z",
    fill: "#2E3430"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7217 36.6418H37.2373L38.9116 30.1113H43.8797L45.7217 36.6418Z",
    fill: "#202022"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6562 36.8098H59.1718L60.8472 30.2793H65.8141L67.6562 36.8098Z",
    fill: "#202022"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9351 38.4793C55.9351 38.7922 55.6816 39.0469 55.3687 39.0469H49.3582C49.0453 39.0469 48.7918 38.7934 48.7918 38.4793V35.7578C48.7918 35.4449 49.0453 35.1914 49.3582 35.1914H55.3687C55.6816 35.1914 55.9351 35.4449 55.9351 35.7578V38.4793Z",
    fill: "#202022"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.048 52.069L69.0496 55.1438L70.8679 56.6801L71.2284 56.6789C85.3496 56.3433 83.9538 51.1527 82.1118 48.1398C80.3423 45.2434 70.7953 51.568 70.048 52.069Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9932 52.2377L68.9937 55.3126L70.8119 56.8488L71.1725 56.8464C85.2937 56.5108 83.8979 51.3203 82.0558 48.3061C80.2875 45.4109 70.7393 51.7367 69.9932 52.2377Z",
    fill: "#292929"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.889 55.4372L68.8057 55.367L68.839 55.2623L69.8112 52.2695H33.8162L34.7884 55.2623L34.8217 55.367L34.7372 55.4372L33.0653 56.8497L51.9725 56.9544V56.958L52.2558 56.9568L52.5521 56.958V56.9544L70.562 56.8509L68.889 55.4372Z",
    fill: "#212320"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2514 52.0183C81.2514 53.7199 79.8723 55.0991 78.1706 55.0991C76.469 55.0991 75.0898 53.7199 75.0898 52.0183C75.0898 50.3179 76.4702 48.9375 78.1706 48.9375C79.8723 48.9375 81.2514 50.3179 81.2514 52.0183Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9023 52.0183C81.9023 53.7199 80.5232 55.0991 78.8215 55.0991C77.1199 55.0991 75.7407 53.7199 75.7407 52.0183C75.7407 50.3179 77.1199 48.9375 78.8215 48.9375C80.5232 48.9375 81.9023 50.3179 81.9023 52.0183Z",
    fill: "url(#paint0_radial_811_305)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.992 49.833C80.5969 51.0301 79.8937 51.8024 79.8937 51.8024C80.4744 52.6556 80.7849 53.4838 80.9385 54.2537C81.5311 53.692 81.9023 52.9007 81.9023 52.019C81.9023 51.1646 81.5549 50.3911 80.992 49.833ZM76.2548 50.3173C75.9311 50.8052 75.7407 51.3895 75.7407 52.019C75.7407 52.9804 76.181 53.8372 76.87 54.4024C77.0913 54.431 77.2341 54.4346 77.2341 54.4346C76.7189 53.2672 78.2384 52.3712 78.2384 52.3712C77.6411 52.0999 76.7986 51.0563 76.2548 50.3173Z",
    fill: "url(#paint1_linear_811_305)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.432 51.9777C79.432 52.2252 79.2321 52.4251 78.9846 52.4251C78.737 52.4251 78.5371 52.2252 78.5371 51.9777C78.5371 51.7302 78.7382 51.5303 78.9846 51.5303C79.2321 51.5303 79.432 51.7302 79.432 51.9777Z",
    fill: "url(#paint2_linear_811_305)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2944 54.8133L78.3206 52.4238L78.5347 52.4262L78.5086 54.8156L78.2944 54.8133Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7846 53.1233L78.9953 53.084L79.2939 54.6857L79.0821 54.7249L78.7846 53.1233Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4617 52.2669L79.6759 52.2598C79.6759 52.261 79.7318 54.0352 79.7556 54.172L79.5438 54.2065C79.5141 54.0185 79.4617 52.2717 79.4617 52.2669Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3448 49.6983L77.5566 49.6709L77.8279 51.7878L77.6161 51.8152L77.3448 49.6983Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0766 49.5268L78.2908 49.5137L78.3991 51.2784L78.1849 51.2915L78.0766 49.5268Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8906 51.3866L79.0274 49.4053L79.2404 49.4196L79.1047 51.402L78.8906 51.3866Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3273 51.0705L79.6807 49.5771L79.8901 49.6271L79.5355 51.1205L79.3273 51.0705Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.289 54.0545C74.289 55.2838 73.2918 56.2809 72.0626 56.2809C70.8334 56.2809 69.8362 55.2838 69.8362 54.0545C69.8362 52.8253 70.8334 51.8281 72.0626 51.8281C73.293 51.8293 74.289 52.8253 74.289 54.0545Z",
    fill: "url(#paint3_radial_811_305)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6309 52.4756C73.3465 53.3395 72.8372 53.8976 72.8372 53.8976C73.2573 54.514 73.481 55.1125 73.5929 55.6682C74.0201 55.2625 74.289 54.6901 74.289 54.0547C74.289 53.4371 74.0367 52.8778 73.6309 52.4756ZM70.2086 52.8254C69.9742 53.1777 69.8374 53.6001 69.8374 54.0547C69.8374 54.7484 70.1563 55.3684 70.6537 55.7765C70.8131 55.7968 70.9155 55.8003 70.9155 55.8003C70.543 54.9566 71.6413 54.3105 71.6413 54.3105C71.2106 54.113 70.6013 53.3585 70.2086 52.8254Z",
    fill: "url(#paint4_linear_811_305)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5041 54.0248C72.5041 54.2033 72.3601 54.3485 72.1804 54.3485C72.0019 54.3485 71.8567 54.2045 71.8567 54.0248C71.8567 53.8463 72.0019 53.7012 72.1804 53.7012C72.3589 53.7012 72.5041 53.8463 72.5041 54.0248Z",
    fill: "url(#paint5_linear_811_305)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M71.652 56.0731L71.6711 54.3477L71.8853 54.35L71.865 56.0755L71.652 56.0731Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0066 54.8596L72.2173 54.8203L72.4327 55.9769L72.222 56.0162L72.0066 54.8596Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4945 54.2347L72.7087 54.2275C72.7099 54.2287 72.7492 55.5139 72.7658 55.6055L72.554 55.6412C72.5326 55.4972 72.4957 54.2406 72.4945 54.2347Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9654 52.3809L71.1784 52.3535L71.3748 53.8838L71.1618 53.9112L70.9654 52.3809Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M71.495 52.2572L71.7092 52.2441L71.7865 53.5198L71.5735 53.5329L71.495 52.2572Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0828 53.5966L72.1816 52.165L72.3946 52.1793L72.297 53.6108L72.0828 53.5966Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3993 53.3625L72.6552 52.2832L72.8634 52.3332L72.6076 53.4113L72.3993 53.3625Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.1392 47.7069C80.2899 48.8349 82.0368 51.2839 80.8706 55.0536C84.2763 53.1878 83.2624 50.2819 82.057 48.3078C81.5644 47.5034 80.4744 47.4117 79.1392 47.7069Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1707 51.6458C75.1707 52.261 74.6721 52.7584 74.0581 52.7584C73.4429 52.7584 72.9443 52.2598 72.9443 51.6458C72.9443 51.0306 73.4429 50.5332 74.0581 50.5332C74.6721 50.5332 75.1707 51.0318 75.1707 51.6458Z",
    fill: "#C3BCC3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0367 51.7729L73.3049 52.4655C73.5036 52.6475 73.7678 52.7606 74.0581 52.7606C74.5008 52.7606 74.8828 52.5012 75.0613 52.1263L74.0367 51.7729ZM74.8649 50.8828C74.6626 50.6686 74.3759 50.5342 74.0581 50.5342C73.5703 50.5342 73.1561 50.8483 73.0062 51.285L74.0581 51.648L74.8649 50.8828Z",
    fill: "#806D67"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.0544 55.1283L68.9949 55.3127L69.7755 55.9719C76.8331 55.5507 81.1979 52.5615 81.1979 52.5615C77.3686 54.5083 71.4414 55.0045 69.0544 55.1283Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4961 52.07L34.4957 55.1448L32.6774 56.681L32.3169 56.6799C18.1956 56.3443 19.5915 51.1537 21.4335 48.1407C23.2018 45.2444 32.75 51.569 33.4961 52.07Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5532 52.2377L34.5516 55.3126L32.7333 56.8488L32.3728 56.8464C18.2516 56.5108 19.6474 51.3203 21.4894 48.3061C23.2589 45.4109 32.8059 51.7367 33.5532 52.2377Z",
    fill: "#292929"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.295 52.0183C22.295 53.7199 23.6742 55.0991 25.3758 55.0991C27.0775 55.0991 28.4566 53.7199 28.4566 52.0183C28.4566 50.3179 27.0775 48.9375 25.3758 48.9375C23.6742 48.9375 22.295 50.3179 22.295 52.0183Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.643 52.0183C21.643 53.7199 23.0233 55.0991 24.7237 55.0991C26.4254 55.0991 27.8045 53.7199 27.8045 52.0183C27.8045 50.3179 26.4254 48.9375 24.7237 48.9375C23.0221 48.9375 21.643 50.3179 21.643 52.0183Z",
    fill: "url(#paint6_radial_811_305)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.643 52.019C21.643 52.8995 22.0142 53.692 22.6056 54.2537C22.7603 53.4838 23.0709 52.6556 23.6516 51.8024C23.6516 51.8024 22.9483 51.0301 22.5533 49.833C21.9916 50.3911 21.643 51.1646 21.643 52.019ZM25.3068 52.3724C25.3068 52.3724 26.8276 53.2684 26.3111 54.4358C26.3111 54.4358 26.4551 54.431 26.6753 54.4036C27.3643 53.8384 27.8045 52.9804 27.8045 52.0201C27.8045 51.3907 27.6153 50.8064 27.2917 50.3185C26.7467 51.0563 25.9042 52.0999 25.3068 52.3724Z",
    fill: "url(#paint7_linear_811_305)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1133 51.9777C24.1133 52.2252 24.3132 52.4251 24.5607 52.4251C24.8082 52.4251 25.0093 52.2252 25.0093 51.9777C25.0093 51.7302 24.8082 51.5303 24.5607 51.5303C24.3132 51.5303 24.1133 51.7302 24.1133 51.9777Z",
    fill: "url(#paint8_linear_811_305)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0105 52.4262L25.2247 52.4238L25.2521 54.8133L25.0379 54.8156L25.0105 52.4262Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2513 54.6857L24.55 53.084L24.7606 53.1233L24.4631 54.7249L24.2513 54.6857Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7896 54.172C23.8134 54.0352 23.8706 52.2621 23.8694 52.2598L24.0836 52.2657C24.0824 52.2717 24.03 54.0185 24.0003 54.2077L23.7896 54.172Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7162 51.7878L25.9887 49.6709L26.2005 49.6983L25.9292 51.8152L25.7162 51.7878Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1462 51.2784L25.2545 49.5137L25.4687 49.5268L25.3604 51.2915L25.1462 51.2784Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3049 49.4207L24.5191 49.4053L24.6535 51.3866L24.4405 51.4008L24.3049 49.4207Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6564 49.6281L23.8646 49.5781L24.2168 51.0715L24.0086 51.1215L23.6564 49.6281Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2575 54.0555C29.2575 55.2847 30.2535 56.2819 31.4827 56.2819C32.7119 56.2819 33.7091 55.2847 33.7091 54.0555C33.7091 52.8263 32.7119 51.8291 31.4827 51.8291C30.2535 51.8303 29.2575 52.8263 29.2575 54.0555Z",
    fill: "url(#paint9_radial_811_305)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2575 54.0556C29.2575 54.6911 29.5252 55.2634 29.9536 55.6692C30.0655 55.1135 30.2892 54.515 30.7092 53.8986C30.7092 53.8986 30.2011 53.3405 29.9155 52.4766C29.5086 52.8788 29.2575 53.438 29.2575 54.0556ZM31.9039 54.3115C31.9039 54.3115 33.0023 54.9588 32.6298 55.8013C32.6298 55.8013 32.7333 55.7989 32.8928 55.7775C33.3902 55.3693 33.7079 54.7494 33.7079 54.0556C33.7079 53.6011 33.5711 53.1786 33.3367 52.8264C32.944 53.3595 32.3359 54.1139 31.9039 54.3115Z",
    fill: "url(#paint10_linear_811_305)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0412 54.0258C31.0412 54.2043 31.1864 54.3495 31.3649 54.3495C31.5434 54.3495 31.6886 54.2055 31.6886 54.0258C31.6886 53.8473 31.5434 53.7021 31.3649 53.7021C31.1864 53.7021 31.0412 53.8473 31.0412 54.0258Z",
    fill: "url(#paint11_linear_811_305)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M31.66 54.35L31.8742 54.3477L31.8932 56.0731L31.6802 56.0755L31.66 54.35Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1126 55.9779L31.328 54.8213L31.5386 54.8606L31.3232 56.0172L31.1126 55.9779Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7794 55.6075C30.7961 55.5158 30.8366 54.2307 30.8366 54.2295L31.0507 54.2354C31.0507 54.2414 31.0127 55.498 30.9901 55.642V55.6432L30.7794 55.6075Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1705 53.8848L32.3668 52.3545L32.5798 52.3819L32.3835 53.9121L32.1705 53.8848Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7588 53.5198L31.8361 52.2441L32.0503 52.2572L31.9718 53.5329L31.7588 53.5198Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1495 52.1803L31.3637 52.166L31.4625 53.5975L31.2483 53.6118L31.1495 52.1803Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6819 52.3351L30.8913 52.2852L31.1459 53.3644L30.9377 53.4132L30.6819 52.3351Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.406 47.7069C23.2553 48.8349 21.5085 51.2839 22.6746 55.0536C19.269 53.1878 20.2828 50.2819 21.4883 48.3078C21.9797 47.5034 23.0709 47.4117 24.406 47.7069Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3745 51.6448C28.3745 52.26 28.8731 52.7574 29.4871 52.7574C30.1023 52.7574 30.5998 52.2589 30.5998 51.6448C30.5998 51.0296 30.1012 50.5322 29.4871 50.5322C28.8731 50.5322 28.3745 51.0308 28.3745 51.6448Z",
    fill: "#C3BCC3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M28.484 52.1246C28.6637 52.4994 29.0445 52.7588 29.4871 52.7588C29.7787 52.7588 30.0429 52.6458 30.2404 52.4637L29.5086 51.7712L28.484 52.1246ZM29.4871 51.645L30.5391 51.2821C30.3891 50.8466 29.975 50.5312 29.4871 50.5312C29.1694 50.5312 28.8826 50.6657 28.6792 50.8799L29.4871 51.645Z",
    fill: "#806D67"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.4909 55.1283L34.5516 55.3127L33.771 55.9719C26.7134 55.5507 22.3486 52.5615 22.3486 52.5615C26.1767 54.5083 32.1039 55.0045 34.4909 55.1283Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9495 56.5298L51.9702 56.6321L52.2581 56.6309L52.5544 56.6321L52.5497 56.6298L69.6779 56.5298L69.0294 55.9824H34.598L33.9495 56.5298Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0597 55.0445H68.5677L68.8247 54.252H34.8015L35.0597 55.0445ZM34.3386 52.8252L34.4909 53.294H69.1353L69.2876 52.8252H34.3386Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8559 63.7404C51.8524 63.7404 51.8476 63.7404 51.844 63.7404C51.8417 63.7404 51.8357 63.7404 51.8333 63.7404C50.8504 63.7428 42.7813 63.7547 35.2596 63.5595C35.8974 65.4456 37.705 69.3367 41.8103 69.4998C45.479 69.6461 50.19 69.6687 52.8579 69.6687C55.5269 69.6687 60.2368 69.6461 63.9066 69.4998C68.056 69.3344 69.8576 65.3635 70.4776 63.5C62.4454 63.7582 52.9281 63.7428 51.8559 63.7404Z",
    fill: "#030303"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M52.777 68.7674C47.2675 68.7674 42.6005 68.6044 39.3102 68.4414C39.0532 68.4283 38.8045 68.4164 38.5641 68.4033C38.6498 68.464 38.7379 68.5235 38.8283 68.5794C42.1388 68.7508 46.995 68.9293 52.777 68.9293C58.4828 68.9293 63.4318 68.7544 66.8779 68.5866C66.9672 68.5295 67.0564 68.4711 67.1421 68.4105C66.9386 68.4212 66.7292 68.4307 66.5138 68.4414C63.0891 68.6044 58.2853 68.7674 52.777 68.7674Z",
    fill: "#323232"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M52.777 67.7907C47.2675 67.7907 42.6005 67.6277 39.3102 67.4646C38.6082 67.4301 37.9691 67.3956 37.3992 67.3623C37.4515 67.4206 37.5051 67.4777 37.561 67.5348C40.831 67.7217 46.206 67.9537 52.7782 67.9537C59.2265 67.9537 64.7075 67.7312 68.1476 67.5456C68.2024 67.4884 68.2571 67.4313 68.3095 67.3742C67.7633 67.404 67.1647 67.4349 66.515 67.4658C63.0891 67.6277 58.2853 67.7907 52.777 67.7907Z",
    fill: "#323232"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5138 64.5324C63.0879 64.6966 58.2841 64.8585 52.7758 64.8585C47.2663 64.8585 42.5993 64.6966 39.309 64.5324C37.7026 64.4539 36.4258 64.3742 35.5393 64.3135C35.5619 64.3682 35.5857 64.4253 35.6095 64.4813C38.363 64.6681 44.6555 65.0215 52.7758 65.0215C60.6342 65.0215 67.0552 64.6907 70.0968 64.5003C70.1218 64.4432 70.1444 64.3873 70.1658 64.3325C69.2519 64.3908 68.0167 64.4622 66.5138 64.5324Z",
    fill: "#323232"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M52.777 65.8354C47.2675 65.8354 42.6005 65.6723 39.3102 65.5093C37.9668 65.4427 36.853 65.376 36.0069 65.3213C36.0355 65.3772 36.0652 65.4332 36.0962 65.4903C39.0591 65.6819 45.1017 65.9984 52.777 65.9984C60.238 65.9984 66.4031 65.6997 69.6113 65.5069C69.641 65.451 69.6708 65.3951 69.7005 65.3391C68.8473 65.3915 67.7752 65.451 66.515 65.5105C63.0891 65.6723 58.2853 65.8354 52.777 65.8354Z",
    fill: "#323232"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M52.777 66.8139C47.2675 66.8139 42.6005 66.6508 39.3102 66.4878C38.2619 66.4367 37.3551 66.3843 36.6043 66.3379C36.6423 66.395 36.6804 66.4509 36.7197 66.5081C39.8612 66.7008 45.6063 66.9769 52.7758 66.9769C59.7775 66.9769 65.638 66.7139 68.9842 66.5223C69.0234 66.4664 69.0627 66.4093 69.1008 66.3522C68.3618 66.395 67.4943 66.4414 66.5126 66.4878C63.0891 66.6508 58.2853 66.8139 52.777 66.8139Z",
    fill: "#323232"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3078 69.3378C71.9483 68.9903 75.279 68.3049 76.8652 67.867C77.2484 67.7611 77.6339 67.654 78.0385 67.5469C79.1702 67.2483 79.9698 66.6949 80.4125 65.9024C80.8968 65.0373 80.8754 64.0449 80.7945 63.4297C79.2463 63.7117 76.4309 63.9104 73.1335 64.052C72.8253 65.3431 72.4838 68.4822 69.3078 69.3378Z",
    fill: "#0A0A0A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5961 67.99C72.3874 66.4728 72.8527 65.0853 73.1228 64.0584C76.2191 63.9192 78.5121 63.7431 79.9544 63.5312C79.9675 64.0477 79.8925 64.6569 79.5902 65.196C79.2142 65.8683 78.5169 66.3431 77.5173 66.6073C77.1484 66.7049 76.795 66.8024 76.4452 66.8988L76.3393 66.9274C74.9518 67.3117 73.6321 67.6759 71.5961 67.99Z",
    fill: "#141414"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M72.798 65.1466C72.7789 65.2025 72.7611 65.2572 72.7421 65.3144C75.3992 65.1025 77.7898 64.8765 79.8116 64.667C79.8282 64.6111 79.8449 64.5552 79.858 64.498C77.841 64.7087 75.454 64.9348 72.798 65.1466ZM72.366 66.3246C74.9054 66.1271 77.2115 65.9141 79.1976 65.7118C79.2547 65.6535 79.307 65.5928 79.3582 65.5309C77.3531 65.7356 75.0149 65.9534 72.4327 66.1545C72.4089 66.2116 72.3886 66.2663 72.366 66.3246Z",
    fill: "#323232"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5849 69.3378C31.9444 68.9903 28.6137 68.3049 27.0275 67.867C26.6443 67.7611 26.2576 67.654 25.8542 67.5469C24.7214 67.2483 23.9229 66.6949 23.4791 65.9024C22.9947 65.0373 23.0162 64.0449 23.0971 63.4297C24.6452 63.7117 27.4606 63.9104 30.7592 64.052C31.0674 65.3431 31.4089 68.4822 34.5849 69.3378Z",
    fill: "#0A0A0A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2966 67.99C31.5053 66.4728 31.04 65.0853 30.7711 64.0584C27.6748 63.9192 25.3818 63.7431 23.9396 63.5312C23.9265 64.0477 24.0014 64.6569 24.3049 65.196C24.6809 65.8683 25.3782 66.3431 26.3778 66.6073C26.7455 66.7049 27.1001 66.8024 27.4499 66.8988L27.5558 66.9274C28.941 67.3117 30.2606 67.6759 32.2966 67.99Z",
    fill: "#141414"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M24.036 64.498C24.049 64.554 24.0657 64.6099 24.0824 64.667C26.1041 64.8765 28.4935 65.1025 31.1507 65.3144C31.1317 65.2572 31.1138 65.2025 31.0948 65.1466C28.44 64.9348 26.0517 64.7087 24.036 64.498ZM31.4613 66.1557C28.8791 65.9534 26.5396 65.7368 24.5357 65.5321C24.5857 65.594 24.6393 65.6547 24.6964 65.713C26.6824 65.9141 28.9886 66.1271 31.5279 66.3258C31.5041 66.2663 31.4839 66.2116 31.4613 66.1557Z",
    fill: "#323232"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 60.5,
    width: 38,
    height: 10,
    rx: 1.5,
    fill: "#E0E0E0",
    stroke: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8864 63.6366C39.8523 63.3488 39.714 63.1253 39.4716 62.9662C39.2292 62.8071 38.9318 62.7275 38.5795 62.7275C38.322 62.7275 38.0966 62.7692 37.9034 62.8525C37.7121 62.9359 37.5625 63.0505 37.4545 63.1963C37.3485 63.3421 37.2955 63.5078 37.2955 63.6934C37.2955 63.8488 37.3324 63.9823 37.4062 64.094C37.482 64.2039 37.5786 64.2957 37.696 64.3696C37.8134 64.4416 37.9366 64.5012 38.0653 64.5486C38.1941 64.594 38.3125 64.6309 38.4205 64.6594L39.0114 64.8184C39.1629 64.8582 39.3314 64.9131 39.517 64.9832C39.7045 65.0533 39.8835 65.1489 40.054 65.2702C40.2263 65.3895 40.3684 65.5429 40.4801 65.7304C40.5919 65.9179 40.6477 66.148 40.6477 66.4207C40.6477 66.7351 40.5653 67.0192 40.4006 67.273C40.2377 67.5268 39.9991 67.7285 39.6847 67.8781C39.3722 68.0277 38.9924 68.1025 38.5455 68.1025C38.1288 68.1025 37.768 68.0353 37.4631 67.9008C37.16 67.7664 36.9214 67.5789 36.7472 67.3383C36.5748 67.0978 36.4773 66.8184 36.4545 66.5003H37.1818C37.2008 66.72 37.2746 66.9018 37.4034 67.0457C37.5341 67.1878 37.6989 67.2938 37.8977 67.3639C38.0985 67.4321 38.3144 67.4662 38.5455 67.4662C38.8144 67.4662 39.0559 67.4226 39.2699 67.3355C39.4839 67.2465 39.6534 67.1234 39.7784 66.9662C39.9034 66.8071 39.9659 66.6215 39.9659 66.4094C39.9659 66.2162 39.9119 66.059 39.804 65.9378C39.696 65.8166 39.554 65.7181 39.3778 65.6423C39.2017 65.5666 39.0114 65.5003 38.8068 65.4434L38.0909 65.2389C37.6364 65.1082 37.2765 64.9217 37.0114 64.6792C36.7462 64.4368 36.6136 64.1196 36.6136 63.7275C36.6136 63.4018 36.7017 63.1177 36.8778 62.8753C37.0559 62.6309 37.2945 62.4416 37.5937 62.3071C37.8949 62.1707 38.2311 62.1025 38.6023 62.1025C38.9773 62.1025 39.3106 62.1698 39.6023 62.3042C39.8939 62.4368 40.125 62.6186 40.2955 62.8497C40.4678 63.0808 40.5587 63.3431 40.5682 63.6366H39.8864Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7834 64.0003C45.7209 63.809 45.6385 63.6376 45.5362 63.4861C45.4358 63.3327 45.3156 63.202 45.1754 63.094C45.0372 62.9861 44.88 62.9037 44.7038 62.8469C44.5277 62.79 44.3345 62.7616 44.1243 62.7616C43.7796 62.7616 43.4661 62.8506 43.1839 63.0287C42.9018 63.2067 42.6773 63.469 42.5107 63.8156C42.344 64.1622 42.2607 64.5874 42.2607 65.0912C42.2607 65.595 42.3449 66.0202 42.5135 66.3667C42.6821 66.7133 42.9103 66.9756 43.1982 67.1537C43.486 67.3317 43.8099 67.4207 44.1697 67.4207C44.5031 67.4207 44.7966 67.3497 45.0504 67.2077C45.3061 67.0637 45.505 66.8611 45.647 66.5997C45.791 66.3364 45.8629 66.0268 45.8629 65.6707L46.0788 65.7162H44.3288V65.0912H46.5447V65.7162C46.5447 66.1953 46.4425 66.612 46.2379 66.9662C46.0353 67.3203 45.755 67.595 45.397 67.79C45.041 67.9832 44.6319 68.0798 44.1697 68.0798C43.6546 68.0798 43.2019 67.9586 42.8118 67.7162C42.4235 67.4738 42.1205 67.1291 41.9027 66.6821C41.6868 66.2351 41.5788 65.7048 41.5788 65.0912C41.5788 64.6309 41.6404 64.2171 41.7635 63.8497C41.8885 63.4804 42.0646 63.166 42.2919 62.9065C42.5192 62.647 42.7881 62.4482 43.0987 62.3099C43.4093 62.1717 43.7512 62.1025 44.1243 62.1025C44.4311 62.1025 44.7171 62.1489 44.9822 62.2417C45.2493 62.3327 45.487 62.4624 45.6953 62.6309C45.9055 62.7976 46.0807 62.9974 46.2209 63.2304C46.361 63.4614 46.4576 63.7181 46.5107 64.0003H45.7834Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9446 62.1821V68.0003H51.2401V62.9207H51.206L49.7855 63.8639V63.148L51.2401 62.1821H51.9446Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6179 68.0003V67.4889L55.5384 65.3866C55.7637 65.1404 55.9493 64.9264 56.0952 64.7446C56.241 64.5609 56.349 64.3885 56.419 64.2275C56.491 64.0647 56.527 63.8942 56.527 63.7162C56.527 63.5116 56.4777 63.3345 56.3793 63.1849C56.2827 63.0353 56.1501 62.9198 55.9815 62.8383C55.813 62.7569 55.6236 62.7162 55.4134 62.7162C55.1899 62.7162 54.9948 62.7626 54.8281 62.8554C54.6634 62.9463 54.5355 63.0741 54.4446 63.2389C54.3556 63.4037 54.3111 63.5969 54.3111 63.8184H53.6406C53.6406 63.4775 53.7192 63.1783 53.8764 62.9207C54.0336 62.6631 54.2476 62.4624 54.5185 62.3184C54.7912 62.1745 55.0971 62.1025 55.4361 62.1025C55.777 62.1025 56.0791 62.1745 56.3423 62.3184C56.6056 62.4624 56.812 62.6565 56.9616 62.9008C57.1113 63.1452 57.1861 63.4169 57.1861 63.7162C57.1861 63.9302 57.1473 64.1395 57.0696 64.344C56.9938 64.5467 56.8613 64.773 56.6719 65.023C56.4844 65.2711 56.224 65.5741 55.8906 65.9321L54.5838 67.3298V67.3753H57.2884V68.0003H53.6179Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4276 68.0798C60.0526 68.0798 59.7183 68.0154 59.4247 67.8866C59.133 67.7578 58.901 67.5789 58.7287 67.3497C58.5582 67.1186 58.4654 66.8506 58.4503 66.5457H59.1662C59.1813 66.7332 59.2457 66.8952 59.3594 67.0315C59.473 67.166 59.6217 67.2702 59.8054 67.344C59.9891 67.4179 60.1927 67.4548 60.4162 67.4548C60.6662 67.4548 60.8878 67.4113 61.081 67.3241C61.2741 67.237 61.4257 67.1158 61.5355 66.9605C61.6454 66.8052 61.7003 66.6253 61.7003 66.4207C61.7003 66.2067 61.6473 66.0183 61.5412 65.8554C61.4351 65.6906 61.2798 65.5618 61.0753 65.469C60.8707 65.3762 60.6207 65.3298 60.3253 65.3298H59.8594V64.7048H60.3253C60.5563 64.7048 60.759 64.6631 60.9332 64.5798C61.1094 64.4965 61.2467 64.3791 61.3452 64.2275C61.4455 64.076 61.4957 63.898 61.4957 63.6934C61.4957 63.4965 61.4522 63.3251 61.3651 63.1792C61.2779 63.0334 61.1548 62.9198 60.9957 62.8383C60.8385 62.7569 60.6529 62.7162 60.4389 62.7162C60.2382 62.7162 60.0488 62.7531 59.8707 62.827C59.6946 62.8989 59.5507 63.0041 59.4389 63.1423C59.3272 63.2787 59.2666 63.4434 59.2571 63.6366H58.5753C58.5866 63.3317 58.6785 63.0647 58.8509 62.8355C59.0232 62.6044 59.2486 62.4245 59.527 62.2957C59.8073 62.1669 60.1151 62.1025 60.4503 62.1025C60.8101 62.1025 61.1188 62.1755 61.3764 62.3213C61.634 62.4652 61.8319 62.6556 61.9702 62.8923C62.1084 63.1291 62.1776 63.3847 62.1776 63.6594C62.1776 63.987 62.0914 64.2664 61.919 64.4974C61.7486 64.7285 61.5166 64.8885 61.223 64.9775V65.023C61.5904 65.0836 61.8774 65.2398 62.0838 65.4917C62.2902 65.7417 62.3935 66.0514 62.3935 66.4207C62.3935 66.737 62.3073 67.0211 62.1349 67.273C61.9645 67.523 61.7315 67.72 61.4361 67.8639C61.1406 68.0078 60.8044 68.0798 60.4276 68.0798Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M63.419 66.8071V66.2275L65.9759 62.1821H66.3963V63.0798H66.1122L64.1804 66.1366V66.1821H67.6236V66.8071H63.419ZM66.1577 68.0003V66.6309V66.3611V62.1821H66.8281V68.0003H66.1577Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_811_305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.8218 52.0186) scale(3.08093 3.08093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2489,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_811_305",
    x1: 78.8218,
    y1: 58.7129,
    x2: 78.8218,
    y2: 47.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_811_305",
    x1: 78.9846,
    y1: 53.2578,
    x2: 78.9846,
    y2: 51.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_811_305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0631 54.0548) scale(2.22603 2.22603)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2489,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_811_305",
    x1: 72.0631,
    y1: 58.89,
    x2: 72.0631,
    y2: 51.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_811_305",
    x1: 72.1804,
    y1: 54.9498,
    x2: 72.1804,
    y2: 53.4209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_811_305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7237 52.0186) rotate(180) scale(3.08093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2489,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_811_305",
    x1: 24.7237,
    y1: 58.7129,
    x2: 24.7237,
    y2: 47.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_811_305",
    x1: 24.561,
    y1: 53.2578,
    x2: 24.561,
    y2: 51.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_811_305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.483 54.0558) rotate(180) scale(2.22593 2.22593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2489,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_811_305",
    x1: 31.483,
    y1: 58.891,
    x2: 31.483,
    y2: 51.0338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_811_305",
    x1: 31.365,
    y1: 54.9508,
    x2: 31.365,
    y2: 53.4218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1947,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7681,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#878787"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarPlaceholder);
export default __webpack_public_path__ + "static/media/car-placeholder.258c65275c3c6aebe70e1b02a6892fb1.svg";
export { ForwardRef as ReactComponent };